module.exports = __webpack_public_path__ + "static/media/icon-expand-order-lg.cde27f8b.svg";